module.exports = __webpack_public_path__ + "img/mario_kart_ghost.20e3fad2.jpg";